<template>
  <div id="app">
    <app-nav></app-nav>
    <router-view></router-view>
  </div>
</template>
<script>
import Nav from "./components/NavBar.vue";
export default {
    components:{
        appNav:Nav,
      }
}

</script>
<style scoped>
  #app {
    min-height: 100vh;
  }
  @import './assets/font/stylesheet.css';
  @import './assets/css/style.css';
 @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@500;700&display=swap');
</style>




// WEBPACK FOOTER //
// src/App.vue